import { api } from './client'
import type { AutonomyLevel, Proposal } from '@/types/dashboard'

export function proposeFromWorkflow(workflowId: string) {
  return api<{
    success: boolean
    proposal?: Proposal
    rejection?: { reason: string }
    orchestration?: {
      riskLevel: string
      consensus?: { agreementPct: number }
    }
    error?: { message?: string }
  }>(`/api/proposals/from-workflow/${workflowId}`, {
    method: 'POST',
    body: '{}'
  })
}

export function decideProposal(id: string, decision: 'confirm' | 'dismiss', note?: string) {
  return api<{ success: boolean; proposal: Proposal; error?: string }>(
    `/api/proposals/${id}/decision`,
    {
      method: 'POST',
      body: JSON.stringify({ decision, note })
    }
  )
}

export function setAutonomy(level: AutonomyLevel) {
  return api<{ settings: { level: AutonomyLevel } }>('/api/proposals/settings', {
    method: 'PUT',
    body: JSON.stringify({ level })
  })
}
